export default "__VITE_ASSET__606e5340__"